import axios from 'axios'
import { Domain, FunnelLookup } from '../models'
import config from '../config'
import { FunnelsServices } from '../services'
export const cacheUpdateEvents = {
  FORM_UPDATE: 'form_update',
  SURVEY_UPDATE: 'survey_update',
  CALENDAR_UPDATE: 'calendar_update',
  CUSTOM_VALUE_UPDATE: 'custom_value_update',
  CUSTOM_FIELD_UPDATE: 'custom_field_update',
  DOMAIN_UPDATE: 'domain_update',
  PAGE_PATH_UPDATE: 'page_path_update',
  STEP_PATH_UPDATE: 'step_path_update',
  FUNNEL_SETTINGS: 'funnel_settings',
  STRIPE_SETTINGS: 'stripe_settings',
  FUNNEL_PAGE_REORDERED: 'funnel_page_reordered',
  REDIRECT_UPDATE: 'redirect_update',
  FUNNEL_IMPORTED: 'funnel_import'
}



export function fetchDomainsByLocationId(locationId: string) {
  return Domain.getAllByLocation(locationId)
}

interface CacheUpdateEventParams {
  event_origin:string
  index_type:string
  domains:Array<string>
  isSplitTestPath?:boolean
}
export async function updateCachingIndex(payload:CacheUpdateEventParams) {
  const { event_origin: locationId, index_type: indexType,isSplitTestPath = false } = payload
  if (
    [
      cacheUpdateEvents.FORM_UPDATE,
      cacheUpdateEvents.SURVEY_UPDATE,
      cacheUpdateEvents.CALENDAR_UPDATE,
      cacheUpdateEvents.CUSTOM_VALUE_UPDATE,
      cacheUpdateEvents.CUSTOM_FIELD_UPDATE,
      cacheUpdateEvents.STRIPE_SETTINGS,
    ].includes(indexType)
  ) {
    const allDomains = await fetchDomainsByLocationId(locationId)
    payload.domains = allDomains.map(domain => domain.url)
  }
  try {
    await axios.post(
      config.cacheInvalidateUrl,
      payload
    )
  } catch (error) { }

  if(!isSplitTestPath){
    try {
      await FunnelsServices.invalidateCache({
        domains: payload.domains,
        event: indexType,
        locationId:locationId
      })
    } catch (error) {
      console.error(error)
    }
  }
}

export const fetchDomainsAndPathsForFunnel = async (funnelId:string, locationId:string) => {
  const funnelLookup = await FunnelLookup.getAllByFunnel(funnelId, locationId)
  const paths = []
  const domains = []
  for (let index = 0; index < funnelLookup.length; index++) {
    const lookup = funnelLookup[index];
    paths.push(lookup.path)
    domains.push(lookup.domain)
  }
  return {
    domains: [...new Set(domains)],
    paths: [...new Set(paths)],
  }
}
